import axiosInstance from "./api";

const setup = () => {
  const getClerkToken = async () => {
    try {
      // Wait for Clerk to be available
      if (!window.Clerk) {
        console.warn('⚠️ Clerk not loaded yet');
        return null;
      }
      
      // Wait for session to be ready
      if (!window.Clerk.session) {
        console.warn('⚠️ Clerk session not available yet');
        return null;
      }
      
      const token = await window.Clerk.session.getToken();
      if (!token) {
        console.warn('⚠️ No Clerk token available - user may not be signed in');
      }
      return token;
    } catch (error) {
      console.error('❌ Error getting Clerk token:', error);
      return null;
    }
  };

  axiosInstance.interceptors.request.use(
    async (config) => {
      // In development, always send X-User-Id for local API debug bypass.
      // Backend checks this header before Clerk token validation on counseling routes.
      const isDevelopment = process.env.NODE_ENV === 'development';

      if (isDevelopment && window.Clerk?.user?.id) {
        config.headers["X-User-Id"] = window.Clerk.user.id;
        config.headers["X-User-Email"] = window.Clerk.user.primaryEmailAddress?.emailAddress || '';
      }

      const token = await getClerkToken();
      if (token) {
        config.headers["Authorization"] = 'Bearer ' + token;
        if (isDevelopment && window.Clerk?.user?.id) {
          console.log('🔧 DEBUG: Using Authorization + X-User-Id headers:', window.Clerk.user.id);
        }
      } else if (isDevelopment && window.Clerk?.user?.id) {
        console.log('🔧 DEBUG: Using X-User-Id header only:', window.Clerk.user.id);
      } else {
        // Log missing token for debugging
        console.warn('⚠️ No auth token for request:', config.url);
        if (isDevelopment) {
          console.warn('⚠️ Clerk state:', {
            hasClerk: !!window.Clerk,
            hasUser: !!window.Clerk?.user,
            hasSession: !!window.Clerk?.session,
            userId: window.Clerk?.user?.id,
          });
        }
      }
      return config;
    },
    (error) => {
      console.error('❌ Request interceptor error:', error);
      return Promise.reject(error);
    }
  );
  // axiosInstance.interceptors.response.use(
  //   (res) => {
  //     return res;
  //   },
  //   async (err) => {
  //     console.log(err);
  //     const originalConfig = err.config;
  //     if (originalConfig.url !== "/login" && originalConfig.url !== "/logout" && err.response) {
  //       if ([400, 401, 403].find(el => el === err.response.status) && !originalConfig._retry) {
  //         originalConfig._retry = true;
  //         try {
  //           return axiosInstance(originalConfig);
  //         } catch (_error) {
  //           return Promise.reject(_error);
  //         }
  //       }
  //     }
  //     return Promise.reject(err);
  //   }
  // );
};
export default setup;